import { getSmartListsQuery as _getSmartListsQuery } from '@griply/services';
import { SmartList } from '@griply/types';
import {
  collection,
  CollectionReference,
  Firestore,
  orderBy,
  Query,
  QueryConstraint,
} from 'firebase/firestore';
import { ID } from 'shared/types/id';

import { smartListConverter } from './converters/smart-list';
import { getDatabase, query, where } from './helpers';

export const getSmartListsQuery = async (uid: ID) =>
  _getSmartListsQuery<
    CollectionReference,
    Query<SmartList>,
    QueryConstraint,
    Firestore
  >({
    db: getDatabase(),
    collection,
    query,
    where,
    orderBy,
    userId: uid,
  }).withConverter(smartListConverter);
